function init_soccergame(from_php){
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    var main=$(".place.soccergame");
    var semaphoreSuit= new mySemaphore();

    var girl_id=intval(from_php.girl_id);
console.log(girl_id);
    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex(),
        "loader":_moduleTimeHandler.getNewIndex()
    };

    var girl_name=$.takeGirlImage(girl_id);
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var gameLog=[];
    var secureStr=from_php.secure;




    var gameCanv=main.find("#canvSoccer");




    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });

    main.find(".bookGame").one("open",function(){
        var radius=0,dir_rot=2,dir=1,step=0,obj=main.find(".formSubmit.butLoader.soccer"),
            circleObj=obj.find(".img"),textObj=obj.find(".in"),step_mig=20;
        _moduleTimeHandler.set(timeIndexArr.loader,function(){
            radius=(radius+dir_rot)%360;
            step+=dir;
            circleObj.cssrotate(radius);
            if(step%step_mig<step_mig/2){
                textObj.addClass("hide");
            }
            else{
                textObj.removeClass("hide");
            }
        },50);
    });
    main.find(".bookGameIns").on("close",function(){
        main.find(".bookGame").bookUse("show");
        return false;
    });

    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"soccergame"};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.level)>intval(from_php.level)){
                        _mySound.playSound("girl_smile");
                    }
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                        _mySound.playSound("girl_moan");
                        $.goToLocation("socceranim/"+girl_id+"/1/");
                        return false;
                    }
                    from_php=$.extend(from_php,data);
                    function isEnd(){
                        if(!refuse_response){
                            updateState();
                        }
                        if(typeof on_end=="function"){
                            on_end();
                        }
                    }
                    if(data_send.wait){
                        _moduleTimeHandler.setOne(timeIndexArr.ajax,function(){
                            isEnd();
                        },1500);
                    }
                    else{
                        isEnd();
                    }

                }
                semaphoreSuit.clear();
            },"json");
        }
    }

    function updateState(){

        if(from_php.was_error){
            showState("wrong");
        }
        else if(from_php.time_game){
            showState("game");
        }
        else{
            if(from_php.was_paid==0){
                if(from_php.try_count>0){
                    postAjax({prepare_init:1});
                }
                else{
                    showState("need_try");
                }
            }
            else if(from_php.was_shown==0){
                showState("next");
            }
            else{
                showState("game_init");
            }
        }
        main.attr("data-level",(intval(from_php.level_show)+1))
        main.find(".repeatMoveTriggerJS .in").html("x"+from_php.repeat_count);
    }


    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({prepare_init:1});


        });
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            postAjax({buy_repeat:1});
        });



        updateState();
    }


    var stateFun={
        "wrong":function(){
            if(from_php.level_show>0){
                main.find(".repeatMoveJS").show();
            }
            main.find("#failReasonJS").html(from_php.langs["fail"+from_php.was_error]);
        },
        "init":function(){

        },
        "need_try":function(){

        },
        "next":function(){
            main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);
            main.find(".stateJS[data-state='next'] .popup .up").addClass("girl_"+from_php.girlOnPopup);
        },
        "game_init":function(){
            initGame();
            gameCover.addClass("hide");
        },
        "game":function(){
            gameCover.addClass("hide");
            main.find(".hideOnGameJS").addClass("hide");
            main.find(".showOnGameJS").removeClass("hide");
        }
    };
    function showState(state){
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.soccergame .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);

        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }

        if(state==="next"){
            main.find(".stateJS[data-state='next'] .popup .up").addClass(123);
        }
        state_cur=state;

        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        gameCoverWin.find(".textfill").textfill();
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        stateFun[state]();
    }



    init();




    function initGame(){

        var cursor=[200,200];
        var state={points:0,in_row:0,goal:0,lives:0};
        var conf={bonus:1.2,bonus_count_max:10,
            points:{
                "goal":100,
                "good":500,
                "target":500,
                "target_change":750,
                "target_premium":1000
            },
            points_live:0.1

        };
        conf=$.extend(conf,from_php.conf_soccer);
        var hard=from_php.win_times;
        if(hard==1 || hard==2){
            hard+=3;
        }
        else if(hard>=3){
            hard=10;
        }
        if(typeof from_php.level_show !== "undefined") {
            hard = 5;
        }
        var conf_app={
                level:from_php.level,
                period:30,
                isMobile:0,
                hard:hard,
                hard_max:10,
                target_premium:from_php.target_premium,
                target_change:from_php.target_change
            },
            conf_mobile={
                period:30,
                cursor_speed:10000,
                isMobile:1
            },
            conf_start=copyObj(conf_app);
        if(_isMobile){
            conf_start=$.extend(conf_start,conf_mobile);
        }



        var book=main.find("#bookGameJS");
        book.bookUse("show");
        function startGame(){
            postAjax({start_game:1});
            book.bookUse("hide");
            main.find(".bookGameIns.book").off("close").bookUse("hide");

            main.find(".hideOnGameJS").addClass("hide");
            gameCanv.soccerGame("start");
            gameCanv.on("click touchend",function(e){

                gameCanv.soccerGame("kick");

                e.preventDefault();
            });
            var howlong=Math.round(conf.howlong*conf_start.period/conf_app.period);
            var last_img=6;
//            howlong=3600;
            _timerManager.addTimer(".place.soccergame .timerInGameJS",getCurrentTime()+howlong,1,function(){
                gameCanv.soccerGame("stop",_moduleTimeHandler);
                if(state.points>=intval(conf.points_need)){
                    postAjax({game_conf:(Base64.encode(secureStr))});
                }
                else{
                    postAjax({was_error:1});
                }
            },function(sec_step){
                var cur_img=8-Math.ceil(sec_step/howlong*8);
                if(sec_step==0){
                    cur_img=9;
                }
                if(cur_img!=last_img){
                    var qobj=main.find("#readyJS .circleWrap");
                    var qwidth=qobj.width();
                    qobj.css("background-position",(-qwidth*cur_img)+"px 0px");
                    last_img=cur_img;
                }
            });
            //conf.howlong*1000

        }
        function wasLoaded(){
            main.find(".gameIsLoadingJS").addClass("hide");
            main.find(".gameIsLoadedJS").removeClass("hide");
            main.find(".gameStartJS").one("click",function(){
                startGame();
            });
            _moduleTimeHandler.clear(timeIndexArr.loader);
        }




        function updateGameState(){
            var obj=main.find("#readyJS");
            obj.find(".pointsJS").html(
                numberFormat(state.points,0,0)
            );
            obj.find(".pointsMaxJS").html(
                numberFormat(conf.points_need,0,0)
            );

            var repeat_count = numberFormat(from_php.repeat_count),c;
            obj.find(".chanceWrap").html("");
            for(c=0;c<repeat_count;c++) {
                obj.find(".chanceWrap").append(
                    "<div class='ball'></div>"
                );
            }
            var percent=Math.round(state.points/conf.points_need*100);
            percent=Math.min(percent,100);
            obj.find("#fillPointsJS").css("height",percent+"%");
            var obj_up=obj.find("#fillPointsJS .up");
            if(percent==0 || percent==100){
                obj_up.addClass("hide");
            }
            else{
                obj_up.removeClass("hide");
            }
            var moreObj=obj.find(".moreJS");
            moreObj.html(state.in_row);
        }
        updateGameState();



        gameCanv.on("newEvent",function(){
            var event_arr=gameCanv.soccerGame("takeEventArr");
            var i,k,ev,points=0;
            for(i in event_arr){
                ev=event_arr[i];
                if(ev.fail>0){
                    state.in_row=0;
                    for(k in ev.target_type_arr){
                        type=ev.target_type_arr[k].type;
                        if(type=="explosion" || type=="bomb"){
                            state.lives--;
                            points=Math.round(conf.points_live*state.points);
                            state.points-=points;
                            gameCanv.soccerGame("addText","-"+numberFormat(points),ev.target_type_arr[k].pos,"red");
                        }
                    }
                }
                else{
                    var type,num=0,point_one;
                    points=0;
                    for(k in ev.target_type_arr){
                        type=ev.target_type_arr[k].type;
                        if(typeof conf.points[type]!="undefined"){
                            point_one=Math.pow(conf.bonus,Math.min(state.in_row,conf.bonus_count_max))*conf.points[type];
                            points+=point_one;
                            gameCanv.soccerGame("addText",numberFormat(point_one),ev.target_type_arr[k].pos,"green");
                            num++;
                        }
                    }
                    if(num<intval(ev.succ)){
                        point_one=Math.pow(conf.bonus,Math.min(state.in_row,conf.bonus_count_max))*conf.points["goal"]*(intval(ev.succ)-num);
                        points+=point_one;
                        gameCanv.soccerGame("addText",numberFormat(point_one),ev.ball_pos,"yellow");
                    }

                    points=Math.round(points);
                    state.points+=points;
                    state.in_row+=intval(ev.succ);

                }
                updateGameState();
            }
        }).on("mousemove touchstart touchmove",function(e){

            cursor[0]=$.getXeventOffset(e);
            cursor[1]=$.getYeventOffset(e);
            e.preventDefault();
        }).one("was_loaded",function(){
            main.find("#gateFast").remove();
            wasLoaded();

        }).soccerGame(conf_start,_moduleTimeHandler,cursor);
    }


    if(!_isMobile && 1==2){
        var imagesObj={
            "1":{
                conf:{period_min:150,period_max:300},
                arr:[
                    {
                        path:_IMG_SERV+"/gfx/place/soccergame/stands.png",
                        conf:{width: 1280, height: 333, left: 0, top: 0, clips: 10}
                    }
                ]
            }
        };
        var qcanv=main.find("#standsCanv");
        qcanv.off("was_loaded").one("was_loaded",function(){
            qcanv.animCircleLoop("start");

        }).animCircleLoop({},imagesObj,_moduleTimeHandler);
    }
}